import { render, staticRenderFns } from "./audit-cashextract.vue?vue&type=template&id=fb2967c4&scoped=true&"
import script from "./audit-cashextract.vue?vue&type=script&lang=js&"
export * from "./audit-cashextract.vue?vue&type=script&lang=js&"
import style0 from "./audit-cashextract.vue?vue&type=style&index=0&id=fb2967c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2967c4",
  null
  
)

export default component.exports